<template>
  <vs-popup :active.sync="popupActive" :title="$t(`timecards.${action}`)" @close="hide" class="holamundo">

    <ValidationObserver class="w-full" ref="validator" v-slot="{ invalid, reset }">
      <form @submit.prevent="doTimecard">
        <div class="flex">
          <date-picker :input-label="$t('timecards.table.date')"
                       :name="$t('timecards.table.date')"
                       class="mx-1"
                       rules="required"
                       v-model="timecardData.date" @input="getProjects"/>

          <date-picker :config="timeConfig"
                       :input-label="$t('timecards.table.start_time')"
                       :name="$t('timecards.table.start_time')"
                       class="mx-1"
                       rules="required"
                       v-model="timecardData.start_time"/>

          <date-picker :config="timeConfig"
                       :input-label="$t('timecards.table.end_time')"
                       :name="$t('timecards.table.end_time')"
                       class="mx-1"
                       rules="required"
                       v-model="timecardData.end_time"/>
        </div>

        <base-multiselect
          :input-label="$t('projects.project')"
          :loading="loadingSelect"
          :options="availableProjects"
          :value="timecardData.project"
          @input="selectProject"
          class="mt-2"
          :custom-label="makeProjectLabel"
          :name="$t('projects.project')"
          rules="required"
          track-by="id"/>

        <base-textarea :input-label="$t('timecards.table.notes')"
                       :name="$t('timecards.table.notes')" :placeholder="$t('timecards.table.notes')"
                       rows="7"
                       class="w-full mt-2 border-gray-400"
                       rules="required"
                       :disabled="timecardData.user && currentUserId !== timecardData.user.id"
                       v-model="timecardData.notes"/>
        <div class="flex justify-center mt-5">
          <base-button :loading="loadingActions" button="filled" class="flex-1 mr-2" color="success" type="submit">
            {{ $t('buttons.save') }}
          </base-button>
          <base-button class="flex-1 ml-2" :loading="loadingActions" color="warning" button="filled" type="button"
                       @click="hide">
            {{ $t('buttons.cancel') }}
          </base-button>
        </div>
      </form>
    </ValidationObserver>

  </vs-popup>
</template>

<script>
  import DatePicker from "../DatePicker";
  import BaseButton from "../_base-button";
  import Users from "../../services/Users";
  import Timecards from "../../services/Timecards";
  import EventBus from "../../utilities/eventBus";

  export default {
    name:"TimecardDetailsModal",
    components:{BaseButton, DatePicker},
    data:() => ({
      timecardData:{date:new Date()},
      timeConfig:{
        enableTime:true,
        noCalendar:true,
        dateFormat:"H:i",
        time_24hr:true
      },
      action:null,
      availableProjects:[],
      loadingSelect:false,
      loadingActions:false,
      popupActive:false
    }),
    methods:{
      getProjects() {
        this.loadingSelect = true
        const query = {date: this.timecardData.date, include: 'client'}
        Users.getProjects(this.currentUserId, query).then(result => {
          this.availableProjects = result.data
        }).catch(error => {
          this.$notificationService.error(error.message)
        }).finally(() => {
          this.loadingSelect = false
        })
      },
      doTimecard() {
        return this.action === 'create' ? this.createTimecard() : this.updateTimecard()
      },
      updateTimecard() {
        this.loadingActions = true
        Timecards.update(this.timecardData).then(() => {
          this.clearSelection()
          this.$notificationService.success(`${this.$t('timecards.timecard')} ${this.$t('notification.successCreate')}`)
        }).catch(error => {
          this.$notificationService.error(error.message)
        }).finally(() => {
          this.loadingActions = false
        })
      },
      createTimecard() {
        this.loadingActions = true;
        Timecards.create(this.timecardData).then(() => {
          this.clearSelection();
          this.$notificationService.success(`${this.$t('timecards.timecard')} ${this.$t('notification.successCreate')}`)
        }).catch(error => {
          this.$notificationService.error(error.message)
        }).finally(() => {
          this.loadingActions = false
        })
      },
      selectProject(project) {
        this.timecardData.project_id = project ? project.id : null
      },
      show(timecard, action) {
        this.popupActive = true;
        this.timecardData = Object.assign(this.timecardData, timecard);
        this.action = action;
        if (this.$refs.validator) this.$refs.validator.reset()
      },
      hide() {
        this.action = null;
        this.timecardData = {date:new Date()};
        this.timecardData.project = {};
        this.popupActive = false
      },
      clearSelection () {
        EventBus.$emit('timecardDone');
        this.hide()
      },
      makeProjectLabel({client,name}) {
        return `${client.name} - ${name}`
      }
    },
    computed:{
      currentUserId() {
        return this.$store.state.me.id
      }
    },
    mounted() {
      EventBus.$on('updateTimecard', (timecard) => {
        this.show(timecard, 'update')
      });
      EventBus.$on('createTimecard', (date) => {
        this.show({
          date: date ? date : new Date()
          }, 'create')
      })
    }
  }
</script>

<style scoped>

</style>
